<!-- double-click edits one field at a time (0124): on the amount the amount, anywhere else on the row the name -->
<div class="bom-tree-node-content" [class.selected]="item.id === selectedNodeId" [title]="tooltip()" (click)="onRowClick()" (dblclick)="startEditing('name')" (contextmenu)="onContextMenu($event)">
  @if (depthLevel > 0) {
    <div class="bom-tree-node-horizontal-connector"></div>
  }

  <!-- the name editor takes the name's slot; the description and the indicators give way while it is open -->
  @if (editing() === 'name') {
    <input class="bom-tree-node-name-input" #editInput [value]="item.data.name" (keyup.enter)="saveName(editInput.value)" (keyup.escape)="stopEditing()" (blur)="stopEditing()">
  } @else {
    <div>{{ item.data.name }}</div>
    <!-- the description beside the designation (0096), only when it says something the name does not -->
    @if (hint(); as hint) {
      <div class="bom-tree-node-description">{{ hint }}</div>
    }
    @if (item.data.hasNotes) {
      <div class="tree-node-indicator" title="Notatki">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z" />
        </svg>
      </div>
    }
    @if (item.data.hasAttachments) {
      <div class="tree-node-indicator" title="Załączniki">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
        </svg>
      </div>
    }
  }
  <!-- the amount editor of client-order-tree-node, shipment and orders-new; the unit stays printed after it -->
  <div class="bom-tree-node-amount" [attr.title]="amountEditable ? 'Dwuklik zmienia ilość' : null" (dblclick)="onAmountDoubleClick($event)">
    @if (editing() === 'amount') {
      <input #editInput inputmode="decimal" [value]="formatAmountInput(item.data.amount)" (keyup.enter)="saveAmount(editInput.value)" (keyup.escape)="stopEditing()" (blur)="stopEditing()"> {{ item.data.unit }}
    } @else {
      {{ formatAmount(item.data.amount, item.data.unit) }}
    }
  </div>
</div>

<div class="bom-tree-node-children">
  @for (child of item.children; track child.id) {
    <bom-tree-node [item]="child" [selectedNodeId]="selectedNodeId" [depthLevel]="depthLevel + 1"></bom-tree-node>
  }
</div>
